import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useOfferStore = defineStore('offer', _ => {
    const selectedPacketId = ref('')
    const packetPrice = ref('')
    const companyId = ref('')
    const showSelected = ref(false)

    const handleOffer = offerData => {
        companyId.value = offerData?.companyId
        selectedPacketId.value = offerData?.selectedPacketId
        packetPrice.value = offerData?.packetPrice
    }

    const hasSelectedPacket = () => Boolean(selectedPacketId.value && companyId.value && packetPrice.value)

    const isPacketSelectedByUser = result => {
        if (hasSelectedPacket())
            return result.packageId == selectedPacketId.value && result.company.id == companyId.value

        return false
    }

    const setShowSelected = value => showSelected.value = value

    return {
        companyId,
        selectedPacketId,
        hasSelectedPacket,
        isPacketSelectedByUser,
        packetPrice,
        showSelected,
        setShowSelected,
        handleOffer
    }
})